import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import '../assets/stylesheets/advancesearchmovies.css';

export default function AdvanceSearchTV() {
  const apiKey = process.env.REACT_APP_TMDB_API_KEY;
  const [genres, setGenres] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [releaseDateURL, setReleaseDateURL] = useState();
  const [languageURL, setLanguageURL] = useState();
  const [genreURL, setGenreURL] = useState([]);
  const [tvList, setTvList] = useState([]);
  const baseURL = `https://api.themoviedb.org/3/discover/tv?api_key=${apiKey}`;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        let api = baseURL;
        if (releaseDateURL) {
          api += `&first_air_date.gte=${releaseDateURL}&first_air_date.lte=${releaseDateURL}`;
        }
        if (languageURL) {
          api += `&language=${languageURL}`;
        }
        if (genreURL.length > 0) {
          api += `&with_genres=${genreURL.toString()}`;
        }
        api += `&page=${currentPage}`;

        const response = await axios.get(api);

        if (response && response.data.results.length > 0) {
          setTvList(response.data.results);

          setTotalPages(response.data['total_pages']);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    fetchData();
  }, [releaseDateURL, languageURL, genreURL, currentPage]);

  useEffect(() => {
    async function fetchGenreAndLanguage() {
      try {
        const tvsList = await axios.get(baseURL);
        if (tvsList && tvsList.data.results.length > 0) {
          setTvList(tvsList.data.results);
        }

        const responseLanguage = await axios.get(
          'https://api.themoviedb.org/3/configuration/languages?api_key=5885fe9dd784d8e0af439f0d75b6dda5',
        );

        const responseGenre = await axios.get(
          'https://api.themoviedb.org/3/genre/tv/list?api_key=5885fe9dd784d8e0af439f0d75b6dda5',
        );

        if (responseGenre.data && responseGenre.data.genres) {
          setGenres(responseGenre.data.genres);
        }
        if (responseLanguage.data) {
          setLanguages(responseLanguage.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    fetchGenreAndLanguage();
  }, []);

  function handleDateChange(e) {
    setReleaseDateURL(e.target.value);
    setCurrentPage(1);
  }

  function handleLanguageChange(e) {
    setLanguageURL(e.target.value);
    setCurrentPage(1);
  }

  function handleGenreChange(e) {
    const genreId = e.target.value;
    if (e.target.checked) {
      setGenreURL((prev) => [...prev, genreId]);
    } else {
      setGenreURL((prev) => prev.filter((item) => item !== genreId));
    }
    setCurrentPage(1);
  }

  function handleSearchCategoryChange(e) {
    if (e.target.value === 'Movies') {
      return navigate('/advance-search/oldmovies');
    }
    if (e.target.value === 'TV') {
      return navigate('/advance-search/oldtv');
    }
    if (e.target.value === 'All') {
      navigate('/advance-search/oldall');
    }
  }

  function handlePrevious() {
    if (currentPage !== 1) {
      setCurrentPage((prev) => Number(prev) - 1);
    }
  }
  function handleNext() {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  }
  return (
    <div className="max-w-screen-xl mx-auto mt-4">
      <div className="flex flex-col md:flex-row">
        {/* Left Sidebar */}
        <div className="bg-gray-900 p-2 lg:py-4 lg:px-2 mt-4 w-full md:w-1/4 rounded-lg h-fit overflow-y-auto">
          {/* Category */}
          <div className="flex py-2 px-6 flex-wrap mt-2">
            <h3 className="text-lg font-semibold text-secondary">Category</h3>
            <select
              className="sidebar-caption"
              onChange={(e) => {
                handleSearchCategoryChange(e);
              }}
            >
              <option value="TV">TV Shows</option>
              <option value="Movies">Movies</option>
              <option value="All">All</option>
            </select>
          </div>

          {/* Release Date */}
          <div className="py-2 px-6">
            <h3 className="text-lg font-semibold text-secondary">
              Release Date
            </h3>

            <ul className="sidebar-list">
              <input
                type="date"
                name="releaseDateURL"
                value={releaseDateURL}
                onChange={(e) => handleDateChange(e)}
              ></input>
            </ul>
          </div>

          {/* Language */}
          <div className="py-2 px-6">
            <h3 className="text-lg font-semibold text-secondary">Language</h3>
            <ul className="sidebar-list">
              <select
                name="language"
                id="language"
                value={languageURL}
                onChange={(e) => handleLanguageChange(e)}
              >
                <option value="">Select language</option>
                {languages.map((language, index) => (
                  <option value={language['iso_639_1']} key={index}>
                    {' '}
                    {language['english_name']}
                  </option>
                ))}
              </select>
            </ul>
          </div>

          {/* Genres */}
          <div className="py-2 px-6">
            <h3 className="text-lg font-semibold text-secondary">Genres</h3>
            <div className="flex flex-wrap gap-2">
              {genres.map((genre) => (
                <label
                  key={genre.id}
                  className={`cursor-pointer px-3 py-1 rounded-full text-sm font-medium border ${
                    genreURL.includes(String(genre.id))
                      ? 'bg-secondary text-primary'
                      : 'bg-gray-200 text-gray-700'
                  }`}
                >
                  <input
                    type="checkbox"
                    id={genre.id}
                    name={genre.name}
                    value={genre.id}
                    className="hidden"
                    onChange={handleGenreChange}
                    checked={genreURL.includes(String(genre.id))}
                  />
                  {genre.name}
                </label>
              ))}
            </div>
          </div>
        </div>

        {/* Right Content */}
        <div className="px-5 mt-4 flex-1">
          <div className="grid place-items-center lg:grid-cols-4 grid-cols-2 gap-3">
            {tvList.map((tv) => (
              <a href={`/rate/tv/${tv.id}`} key={tv.id}>
                <div className="rounded-3xl shadow-xl overflow-hidden transform transition-transform duration-300 hover:scale-105 hover:shadow-2xl">
                  <img
                    src={`https://image.tmdb.org/t/p/w500/${tv.poster_path}`}
                    alt={tv.title}
                    className="movie-poster"
                  />
                </div>
              </a>
            ))}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-center my-5">
              <button
                className={`px-4 py-2 rounded-full shadow-md transition-transform duration-300
                 ${currentPage === 1 ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-secondary text-primary'}`}
                onClick={handlePrevious}
                disabled={currentPage === 1}
              >
                &lt; Previous
              </button>

              <span className="mx-4 text-lg font-semibold flex justify-center items-center bg-gray-100 text-gray-700 px-4 py- rounded-full shadow-md">
                {currentPage} / {totalPages}
              </span>

              <button
                className={`px-4 py-2 rounded-full shadow-md transition-transform duration-300 
                ${currentPage === totalPages ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-secondary text-primary'}`}
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                Next &gt;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
